import { IInvoicingConfig } from "@wingspanhq/payments/dist/interfaces";

const FORCE_ALLOW_USER_IDS = [
  //https://linear.app/wingspan/issue/PLA-859/fe-allow-invoices-regardless-of-payables-strategy-if-they-from-ws
  "t6yjwwQ2Ixa5uxp0ulZc6k"
];

export const selectorIsPayeeAllowedToInitiateInvoice = (
  config: IInvoicingConfig | null | undefined,
  userId: string
): boolean => {
  if (FORCE_ALLOW_USER_IDS.includes(userId)) {
    return true;
  }

  return config ? config.allowPayeeInitiatedInvoices?.enabled !== false : true;
};
